import { Typography } from "interfaces/typography";

export const LoadingState = () => (
    <div className="w-full h-full flex flex-col items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6">
        {/* Animated loading spinner */}
        <div className="relative w-16 h-16">
          <div className="absolute top-0 left-0 w-full h-full border-4 border-gray-200 rounded-full"></div>
          <div className="absolute top-0 left-0 w-full h-full border-4 border-indigo-600 rounded-full animate-spin border-t-transparent"></div>
        </div>
        
        {/* Loading text with animated dots */}
        <div className="flex items-center gap-1">
          <Typography variant="h3" color="gray">
            Loading transcript
          </Typography>
          <span className="animate-[dots_1.5s_ease-in-out_infinite] text-indigo-600">.</span>
          <span className="animate-[dots_1.5s_ease-in-out_infinite_0.2s] text-indigo-600">.</span>
          <span className="animate-[dots_1.5s_ease-in-out_infinite_0.4s] text-indigo-600">.</span>
        </div>
        
        <Typography variant="mediumParagraph" color="gray" className="text-center max-w-md">
          Please wait while we prepare your transcript data
        </Typography>
      </div>
    </div>
  );
  
